import { JobSearchQueryBodyFragment } from '@/graphql/generated';

const filterTypes = {
  JobFilterCompany: 'company',
  JobFilterEmploymentType: 'employmentType',
  JobFilterCareerLevel: 'careerLevel',
  JobFilterDiscipline: 'discipline',
  JobFilterIndustry: 'industry',
  JobFilterBenefit: 'benefit',
  JobFilterCountry: 'country',
  JobFilterCity: 'city',
  JobFilterRemoteOption: 'remoteOption',
} as const;

type Filters = keyof typeof filterTypes;

type FiltersParams = (typeof filterTypes)[Filters];

type FiltersQuery = Partial<Record<FiltersParams, string>>;

export const buildSearchParams = (jobSearchQueryBody: JobSearchQueryBodyFragment) => {
  const { keywords, location, filterCollection } = jobSearchQueryBody;

  const locationText = location?.city?.name || location?.text;

  const filters = filterCollection?.reduce<FiltersQuery>((acc, filter) => {
    if (!filter?.__typename) return acc;

    if (filter.__typename === 'JobFilterSalary' && typeof filter.min === 'number' && typeof filter.max === 'number') {
      return { ...acc, salary: `${filter.min}_${filter.max}` };
    }

    if ('entityId' in filter) {
      const paramName = filterTypes[filter.__typename];
      return {
        ...acc,
        [paramName]: acc?.[paramName] ? [...(acc[paramName] as string), filter.entityId] : [filter.entityId],
      };
    }

    return acc;
  }, {});

  const query = {
    ...(keywords && { keywords }),
    ...(locationText && { location: locationText }),
    ...(location?.radius && { radius: `${location.radius}` }),
    ...(location?.city?.id && { cityId: location.city.id }),
    ...(filters && Object.keys(filters).length > 0 && { ...filters }),
  };

  return query;
};
